import React from 'react';
import { Box, Typography, Button } from '@mui/joy';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';

export const Header = () => {
  const location = useLocation();

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 3,
          px: { xs: 2, md: 4 },
          position: 'relative',
          zIndex: 10,
        }}
      >
        {/* Logo */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Logo size={50} />
              <Typography
                level="h4"
                sx={{
                  fontWeight: 700,
                  color: '#ffffff',
                  fontSize: { xs: '1.1rem', md: '1.3rem' },
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}
              >
                Calvet Technology Solutions
              </Typography>
            </Box>
          </Link>
        </motion.div>

        {/* Navigation */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 4 }}>
          {[
            { label: 'Home', path: '/' },
            { label: 'About', path: '/about' },
            { label: 'Blog', path: '/blog' }
          ].map((item, index) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 + 0.3, duration: 0.4 }}
            >
              <Link to={item.path} style={{ textDecoration: 'none' }}>
                <Typography
                  level="body1"
                  sx={{
                    color: (location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))) ? '#2E5BBA' : 'text.secondary',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease',
                    fontWeight: (location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))) ? 600 : 400,
                    '&:hover': {
                      color: '#2E5BBA',
                    },
                  }}
                >
                  {item.label}
                </Typography>
              </Link>
            </motion.div>
          ))}
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 0.4 }}
          >
            <Link to="/contact" style={{ textDecoration: 'none' }}>
              <Button
                variant="solid"
                color="primary"
              >
                Get Estimate
              </Button>
            </Link>
          </motion.div>
        </Box>

        {/* Mobile menu placeholder */}
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <Button variant="outlined" color="primary" size="sm">
            Menu
          </Button>
        </Box>
      </Box>
    </motion.div>
  );
};